import { LoadableAfterPaint } from '@confluence/loadable';
import { PlaceholderPublishButton } from '../src/PlaceholderPublishButton';

export const PublishButtonWithMoreOptions = LoadableAfterPaint({
	loader: async () => {
		return (
			await import(
				/* webpackChunkName: "loadable-PublishButtonWithMoreOptions" */ '../src/PublishButtonWithMoreOptions'
			)
		).PublishButtonWithMoreOptions;
	},
	loading: PlaceholderPublishButton,
});
